import { render, staticRenderFns } from "./roi.vue?vue&type=template&id=2ec93f49&scoped=true"
import script from "./roi.vue?vue&type=script&lang=js"
export * from "./roi.vue?vue&type=script&lang=js"
import style0 from "./roi.vue?vue&type=style&index=0&id=2ec93f49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec93f49",
  null
  
)

export default component.exports